import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight, Briefcase, FileText, Package, Receipt, Truck } from "lucide-react";
import { isEnPath } from "@/lib/lang";

export const ProTopBar = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/espace-pro") || pathname.startsWith("/admin")) return null;
  if (isEnPath(pathname)) return (
    <Link to="/espace-pro" data-testid="pro-top-bar" className="group flex items-center justify-center gap-2 bg-[var(--oz-dark)] text-white text-xs sm:text-sm font-semibold px-4 py-2 min-h-[40px] hover:bg-black transition-colors">
      <Briefcase className="w-4 h-4 shrink-0 text-[var(--oz-gold)]" />
      <span className="truncate">Ozentya trade customer?<span className="hidden sm:inline"> Wholesale prices excl. VAT, order in 2 minutes</span></span>
      <span className="inline-flex items-center gap-1 underline underline-offset-2 shrink-0 text-[var(--oz-gold)]">
        Trade Area <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5" />
      </span>
    </Link>
  );
  return (
    <Link
      to="/espace-pro"
      data-testid="pro-top-bar"
      className="group flex items-center justify-center gap-2 bg-[var(--oz-dark)] text-white text-xs sm:text-sm font-semibold px-4 py-2 min-h-[40px] hover:bg-black transition-colors"
    >
      <Briefcase className="w-4 h-4 shrink-0 text-[var(--oz-gold)]" />
      <span className="truncate">
        Client professionnel Ozentya ?<span className="hidden sm:inline"> Tarifs HT, commande en 2 minutes</span>
      </span>
      <span className="inline-flex items-center gap-1 underline underline-offset-2 shrink-0 text-[var(--oz-gold)]">
        Espace Pro <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5" />
      </span>
    </Link>
  );
};

export const ProHeaderButton = () => {
  const en = isEnPath(useLocation().pathname);
  return (
    <Link
      to="/espace-pro"
      data-testid="header-pro-button"
      className="group inline-flex items-center gap-2 rounded-full bg-[var(--oz-dark)] text-white text-xs sm:text-sm font-semibold pl-3 pr-3.5 sm:pl-4 sm:pr-5 py-2 sm:py-2.5 ring-2 ring-[var(--oz-gold)] hover:bg-black transition-colors whitespace-nowrap"
    >
      <Briefcase className="w-4 h-4 text-[var(--oz-gold)]" />
      <span className="hidden xl:inline text-white/70">{en ? "Ozentya trade customer?" : "Client pro Ozentya ?"}</span>
      <span className="text-[var(--oz-gold)]">{en ? "Trade Area" : "Espace Pro"}</span>
    </Link>
  );
};

const perks = [
  { icon: Receipt, label: "Tarifs professionnels HT" },
  { icon: Package, label: "Commande par lots, en quelques clics" },
  { icon: FileText, label: "Devis et factures PDF instantanés" },
  { icon: Truck, label: "Mondial Relay offert" },
];

export const ProHomeBlock = () => (
  <section data-testid="home-pro-block" className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-8 md:py-12">
    <div className="rounded-3xl bg-[var(--oz-dark)] text-white px-6 py-8 sm:px-12 sm:py-12 border-2 border-[var(--oz-gold)] grid md:grid-cols-[1.4fr_1fr] gap-8 items-center">
      <div>
        <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-[var(--oz-gold)]">
          <Briefcase className="w-4 h-4" /> Clients professionnels Ozentya
        </span>
        <h2 className="mt-3 font-serif text-3xl sm:text-4xl leading-tight">Vous êtes pro ? Commandez directement dans votre Espace Pro.</h2>
        <ul className="mt-6 grid sm:grid-cols-2 gap-3">
          {perks.map(({ icon: Icon, label }) => (
            <li key={label} className="flex items-center gap-2.5 text-sm text-white/85">
              <Icon className="w-4 h-4 text-[var(--oz-gold)] shrink-0" /> {label}
            </li>
          ))}
        </ul>
      </div>
      <div className="flex flex-col gap-3">
        <Link to="/espace-pro" data-testid="home-pro-access" className="group inline-flex items-center justify-center gap-2 rounded-full bg-[var(--oz-gold)] text-[var(--oz-dark)] font-semibold px-7 py-4 min-h-[52px] transition-transform hover:-translate-y-0.5">
          Accéder à l'Espace Pro <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
        </Link>
        <Link to="/espace-pro/connexion" data-testid="home-pro-login" className="inline-flex items-center justify-center rounded-full border border-white/30 px-7 py-3.5 min-h-[48px] text-sm font-semibold hover:border-[var(--oz-gold)] hover:text-[var(--oz-gold)] transition-colors">
          Déjà client pro ? Se connecter
        </Link>
        <Link to="/espace-pro/inscription" data-testid="home-pro-register" className="text-center text-sm text-white/70 underline underline-offset-2 hover:text-white">
          Pas encore de compte ? Ouvrir un compte pro
        </Link>
        <Link to="/devenir-revendeur" data-testid="home-pro-reseller" className="text-center text-sm text-[var(--oz-gold)] underline underline-offset-2 hover:text-white">
          Devenir revendeur Ozentya : tout savoir
        </Link>
      </div>
    </div>
  </section>
);
